export default {
    active_nav: [],//记录所有用户点击过的导航，包括之前有重复的点击,tab标签的显示就是根据该数组中的内容决定
    active_iNow: "",//当前点击导航的cusindex,主要用于点击导航，切换到相应路由
    carData: [],//车型数据->查看记录 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的配置项子项cusindex集合
    accountData: [],//用户账号列表->查看 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
    machineNewOnOff: true,//售机类型管理->在售机型->添加 ：当一个添加tab页打开时候，该值就设置为false;关闭该tab页时，该值设置为true
    productWarranty: [],//用户账号列表->查看详情->产品保修信息 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
    productAuthorize: [],//用户账号列表->查看详情->授权 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
    historyAuthorize: [],//用户账号列表->查看详情->授权->历史记录 tab页:点击前子项链接onoff=true,点击打开后为false,关闭该tab标签后,onoff=true;该数组是tab页上还保留着的查看项子项cusindex集合
    pageRefreshOnOff: false,//由于f5刷新 需要用sessionStorage记住一些信息；但是刷新之后，需要将该值设置为true
    tabVisible: [//pub-head中左边导航与右边tab页的对应数据，因为售机类型配置项可以添加tab，所以会跨模块
        {
            cusindex: "cusindex00",
            cusname: "固件版本管理",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex01",
            cusname: "APP管理",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex02",
            cusname: "扩展文件管理",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
          cusindex: "cusindex03",
          cusname: "整机产品",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
            cusindex: "cusindex10",
            cusname: "多语言管理",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex11",
            cusname: "ECU刷写包",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex12",
            cusname: "汽车索引",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex13",
            cusname: "历史车型数据",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex14",
            cusname: "车型数据授权",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex20",
            cusname: "车系维护",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex21",
            cusname: "车组维护",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
            cusindex: "cusindex22",
            cusname: "车型维护",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },
        {
          cusindex: "cusindex23",
          cusname: "车型文件",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },

        {
          cusindex: "cusindex24",
          cusname: "新版车系维护",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex25",
          cusname: "新版车组维护",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex26",
          cusname: "新版车型维护",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        /*{
            cusindex: "cusindex30",
            cusname: "一键同步",
            orShow: false,
            isActive: false,
            routerName: null,
            ourRouter: null
        },*/

      {
        cusindex: "cusindex15",
        cusname: "康明斯刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex16",
        cusname: "博世刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex17",
        cusname: "德尔福刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex18",
        cusname: "马牌刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex19",
        cusname: "南岳刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },


      {
          cusindex: "cusindex40",
          cusname: "已售设备",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex50",
          cusname: "用户账号列表",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },

        {
          cusindex: "cusindex27",
          cusname: "设备授权",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },


        {
          cusindex: "cusindex51",
          cusname: "投诉列表",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex28",
          cusname: "诊断报告",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex52",
          cusname: "新闻管理",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex53",
          cusname: "产品管理",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex54",
          cusname: "固件",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex55",
          cusname: "app",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
        {
          cusindex: "cusindex56",
          cusname: "车型",
          orShow: false,
          isActive: false,
          routerName: null,
          ourRouter: null
        },
      {
        cusindex: "cusindex57",
        cusname: "图片管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex58",
        cusname: "视频管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex59",
        cusname: "技术服务",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex60",
        cusname: "技术信息",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex61",
        cusname: "公司联系方式",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex62",
        cusname: "信息管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
    ],
    tabVisible_original: [//tabVisible数据备份，因为tab右键关闭所有标签页之后，需要重置该值
      {
        cusindex: "cusindex00",
        cusname: "固件版本管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex01",
        cusname: "APP管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex02",
        cusname: "扩展文件管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex03",
        cusname: "整机产品",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex10",
        cusname: "多语言管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex11",
        cusname: "汽车品牌",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex12",
        cusname: "汽车索引",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex13",
        cusname: "历史车型数据",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex14",
        cusname: "车型数据授权",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex20",
        cusname: "车系维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex21",
        cusname: "车组维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex22",
        cusname: "车型维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex23",
        cusname: "车型文件",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },

      {
        cusindex: "cusindex24",
        cusname: "新版车系维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex25",
        cusname: "新版车组维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex26",
        cusname: "新版车型维护",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      /*{
        cusindex: "cusindex30",
        cusname: "一键同步",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },*/
      {
        cusindex: "cusindex15",
        cusname: "康明斯刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex16",
        cusname: "博世刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex17",
        cusname: "德尔福刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex18",
        cusname: "马牌刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex19",
        cusname: "南岳刷写",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },



      {
        cusindex: "cusindex40",
        cusname: "已售设备",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex50",
        cusname: "用户账号列表",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },

      {
        cusindex: "cusindex27",
        cusname: "设备授权",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },


      {
        cusindex: "cusindex51",
        cusname: "投诉列表",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex28",
        cusname: "诊断报告",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex52",
        cusname: "新闻管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex53",
        cusname: "产品管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex54",
        cusname: "固件",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex55",
        cusname: "app",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex56",
        cusname: "车型",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex57",
        cusname: "图片管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex58",
        cusname: "视频管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex59",
        cusname: "技术服务",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex60",
        cusname: "技术信息",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex61",
        cusname: "公司联系方式",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
      {
        cusindex: "cusindex62",
        cusname: "信息管理",
        orShow: false,
        isActive: false,
        routerName: null,
        ourRouter: null
      },
    ]
  }




// WEBPACK FOOTER //
// ./src/assets/vuex/states.js